import React from "react";
import SellerSection from "../../../subscreens/customer/business/SellerSection";
import Process from "../../../subscreens/customer/business/Process";

import CTA from "../../../subscreens/customer/business/CTA";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import PageHero from "../../../components/general/pageHero/PageHero";
import Footer from "../../../components/general/footer/Footer";
const Business = () => {
  return (
    <>
      <MyNavbar />
      <PageHero
        title="Sell Products"
        breadcrumb="Seller"
        // icon={<FaStore />}
      />
      <SellerSection showExploreButton={false} />
      <Process />

      <CTA />
      <Footer />
    </>
  );
};
export default Business;
